import { OwnStayIngredient } from '@apps/main/modules/recipe/ingredients/ownStayIngredient';

import { IngredientType } from '@libs/trip-planner-interfaces';
import type {
  ExposedActivityIngredient,
  ExposedOwnStayIngredient,
} from '@libs/trip-planner-interfaces';

import {
  createActivityIngredient,
  createExposedActivityIngredient,
} from './recipeSerializer.activity.helpers';

export function createExposedOwnStayIngredient(
  ownStayIngredient: OwnStayIngredient
): ExposedOwnStayIngredient {
  const { searchText, numberOfNights, subIngredients } = ownStayIngredient;

  return {
    ingredientType: IngredientType.OwnStay,
    destination: searchText,
    numberOfNights,
    subIngredients: subIngredients.length
      ? subIngredients.map(createExposedActivityIngredient)
      : undefined,
  };
}

export function createOwnStayIngredient(
  exposedHotelIngredient: ExposedOwnStayIngredient
): OwnStayIngredient {
  const { destination, numberOfNights, subIngredients } =
    exposedHotelIngredient;

  const ownStayIngredient = new OwnStayIngredient(destination);
  ownStayIngredient.numberOfNights = numberOfNights;
  ownStayIngredient.subIngredients =
    subIngredients?.map((subIngredient: ExposedActivityIngredient) =>
      createActivityIngredient(subIngredient, ownStayIngredient.ingredientId)
    ) ?? [];

  return ownStayIngredient;
}
